<template>
  <div class="view-integration-list">
    <page-header :title="title" :subtitle="subtitle" />
    <page-container>
      <h3 class="mb-2">
        {{ _name }}
      </h3>
      <bp-table-header
        class="mb-6"
        :total="pagination.count"
        @refresh="refresh"
      >
        <template #input>
          <bp-input
            v-model="search"
            size="md"
            placeholder="Buscar"
            pre-icon="fa-light fa-search"
            :delay="600"
            @change="refresh"
          />
        </template>

        <template #buttons>
          <bp-button
            size="md"
            label="Nova integração"
            icon="fa-light fa-add"
            @click="addIntegration"
          />
        </template>
      </bp-table-header>

      <bp-data-table
        :data="integrationList"
        :loading="loading"
        :columns="columns"
      />

      <bp-paginator
        class="mt-8"
        v-model="page"
        :pagination="pagination"
        @change-page="dispatch"
      />
    </page-container>

    <component
      v-if="modal"
      :is="modal"
      v-model="modalValue"
      :integration-to-edit="integrationToEdit"
      @refresh="refresh"
      @close="modalValue = false"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    const integrationType = this.$route.meta?.breadcrumbs[1].split("-")[1];
    const title = {
      automations: "Automações"
    }[integrationType];
    const subtitle = {
      automations: "Integre suas ferramentas de automação à Blitzpay"
    }[integrationType];

    return {
      title,
      subtitle,
      name: "Nome da Integração",
      integration: "",

      search: "",
      modal: null,
      modalValue: false,
      page: 1,
      loading: false,
      integrationToEdit: null,

      columns: []
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("integration", ["integrationList", "pagination", "typeEvents"]),
    _name() {
      return "Integrações " + this.name;
    }
  },
  methods: {
    refresh() {
      this.page = 1;
      this.dispatch();
    },
    dispatch(offset = 0) {
      this.loading = true;
      this.$store
        .dispatch("integration/getIntegration", {
          search: this.search,
          offset
        })
        .catch(() => {
          this.$message.error("Erro ao carregar integrações");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    formatStatus(v) {
      return v ? "Ativo" : "Inativo";
    },
    formatStatusColor(v) {
      return v ? "positive" : "negative";
    },

    addIntegration() {
      this.integrationToEdit = null;
      this.modalValue = true;
    },
    editIntegration(integration) {
      this.integrationToEdit = integration;
      this.modalValue = true;
    },
    changeStatus(item) {
      const data = { ...item };
      data.status = !data.status;
      this.$store
        .dispatch("integration/putIntegration", data)
        .then(() => {
          this.$message.success("Status alterado com sucesso");
          this.refresh();
        })
        .catch(() => {
          this.$message.error("Erro ao alterar status");
        });
    },
    deleteIntegration(item) {
      const id = item.id;
      this.$store
        .dispatch("integration/deleteIntegration", id)
        .then(() => {
          this.$message.success("Integração excluída com sucesso");
          this.refresh();
        })
        .catch(() => {
          this.$message.error("Erro ao excluir integração");
        });
    },

    getActions(item) {
      return [
        {
          label: "Editar",
          icon: "fa-light fa-pen",
          click: this.editIntegration
        },
        {
          label: item.status ? "Desativar" : "Ativar",
          color: item.status ? "negative" : "positive",
          icon: "fa-light fa-power-off",
          click: this.changeStatus
        },
        {
          label: "Excluir",
          color: "negative",
          icon: "fa-light fa-trash",
          dialog: {
            variant: "negative",
            enable: true,
            text: "Deseja mesmo remover esta integração?",
            icon: "fa fa-hexagon-exclamation",
            secondaryAction: this.deleteIntegration,
            buttonText: "Cancelar",
            secondaryButtonText: "Confirmar"
          }
        }
      ];
    }
  },
  mounted() {
    this.$store.dispatch("product/get", { limit: 50 });
    this.$store.commit("integration/setIntegration", this.integration);
    this.dispatch();
  }
};
</script>
